export default __webpack_public_path__ + "2cf00dc06f67faff98c270a3f9c59f0c.woff2";